<template>
<div class="chapter">
<div class="inner_page">
<p class="h2p" id="part1"><span><a id="page_xxiii"></a><a href="#/Contents#rpart1">OVERVIEW</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?d2197226